export default "__VITE_ASSET__BpgYg8EP__"